module.exports = __webpack_public_path__ + "static/media/t-image3.b4934fba.jpg";